import { render, staticRenderFns } from "./IconDenmark.vue?vue&type=template&id=9eaccf12&"
import script from "./IconDenmark.vue?vue&type=script&lang=ts&"
export * from "./IconDenmark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports